import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Utility function to merge Tailwind classes
 * Handles conflicts by keeping the last class in the list
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
